import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
} from '@angular/forms';
import { Cities } from 'src/app/model/cities';
import {
  creerCreneauForm,
  creerJourForm,
  creerLieuForm,
} from 'src/app/modules/shared/form/sessions.form';
// ===== MODIF : les formulaires de sessions sont construits dans un fichier partagé =====

// ===== FIN MODIF =====

interface CreneauType {
  debut: string;
  fin: string;
}
@Component({
  selector: 'app-activity-sessions-editor',
  templateUrl: './activity-sessions-editor.component.html',
  styleUrls: ['./activity-sessions-editor.component.css'],
})
export class ActivitySessionsEditorComponent {
  @Input() lieuxArray!: FormArray;
  @Input() villes: Cities[] = [];
  @Input() minDate: string | null = null;
  @Input() maxDate: string | null = null;

  creneauxParDefaut: CreneauType[] = [
    { debut: '09:00', fin: '13:00' },
    { debut: '15:00', fin: '19:00' },
  ];
  nouveauDebut = new FormControl('');
  nouveauFin = new FormControl('');

  constructor(private fb: FormBuilder) {}

  // ---------------------------------------------------------------- accès
  get lieux(): FormGroup[] {
    return this.lieuxArray.controls as FormGroup[];
  }

  jours(lieu: AbstractControl): FormArray {
    return lieu.get('jours') as FormArray;
  }

  creneaux(jour: AbstractControl): FormArray {
    return jour.get('creneaux') as FormArray;
  }
  // ===== DÉBUT AJOUT : nombre de créneaux d'une ville =====
  nbCreneaux(lieu: AbstractControl): number {
    return this.jours(lieu).controls.reduce(
      (t, j) => t + this.creneaux(j).length,
      0,
    );
  }
  // ===== FIN AJOUT =====

  /** Villes du pays, sans celles déjà choisies dans un autre bloc */
  villesDisponibles(indexLieu: number): Cities[] {
    const dejaChoisies = this.lieux
      .filter((_, i) => i !== indexLieu)
      .map((l) => l.get('ville')?.value);
    return this.villes.filter((v) => !dejaChoisies.includes(v.name));
  }

  get resume(): string {
    const nbJours = this.lieux.reduce((t, l) => t + this.jours(l).length, 0);
    const nbCreneaux = this.lieux.reduce(
      (t, l) =>
        t +
        this.jours(l).controls.reduce((s, j) => s + this.creneaux(j).length, 0),
      0,
    );
    return `${this.lieux.length} ville(s) · ${nbJours} jour(s) · ${nbCreneaux} créneau(x)`;
  }

  // ---------------------------------------------------------------- créneaux par défaut
  ajouterCreneauParDefaut(): void {
    const debut = this.nouveauDebut.value;
    const fin = this.nouveauFin.value;
    if (!debut || !fin || fin <= debut) {
      return;
    }
    this.creneauxParDefaut.push({ debut, fin });
    this.creneauxParDefaut.sort((a, b) => a.debut.localeCompare(b.debut));
    this.nouveauDebut.reset('');
    this.nouveauFin.reset('');
  }

  retirerCreneauParDefaut(index: number): void {
    this.creneauxParDefaut.splice(index, 1);
  }

  // ---------------------------------------------------------------- villes
  ajouterLieu(): void {
    this.lieuxArray.push(creerLieuForm(this.fb)); // ← MODIF : fabrique partagée
  }

  supprimerLieu(index: number): void {
    this.lieuxArray.removeAt(index);
  }

  // ---------------------------------------------------------------- jours
  ajouterJour(lieu: AbstractControl): void {
    // ← MODIF : fabrique partagée
    this.jours(lieu).push(
      creerJourForm(this.fb, '', '', this.creneauxParDefaut),
    );
  }

  /** Copie le dernier jour (salle + créneaux) au lendemain, sans les ids : ce sont de nouvelles sessions */
  dupliquerDernierJour(lieu: AbstractControl): void {
    const jours = this.jours(lieu);
    if (!jours.length) {
      this.ajouterJour(lieu);
      return;
    }
    const dernier = jours.at(jours.length - 1).value;
    const creneaux = (dernier.creneaux as CreneauType[]).map((c) => ({
      debut: c.debut,
      fin: c.fin,
    }));
    // ← MODIF : fabrique partagée
    jours.push(
      creerJourForm(
        this.fb,
        this.lendemain(dernier.date),
        dernier.salle,
        creneaux,
      ),
    );
  }

  supprimerJour(lieu: AbstractControl, index: number): void {
    this.jours(lieu).removeAt(index);
  }

  // ---------------------------------------------------------------- créneaux d'un jour
  ajouterCreneau(jour: AbstractControl): void {
    // ← MODIF : fabrique partagée
    this.creneaux(jour).push(creerCreneauForm(this.fb, { debut: '', fin: '' }));
  }

  supprimerCreneau(jour: AbstractControl, index: number): void {
    this.creneaux(jour).removeAt(index);
  }

  // ===== MODIF : creerJour() et creerCreneau() ont rejoint sessions.form.ts =====

  /** "2026-10-06" → "2026-10-07", sans passer par l'UTC */
  private lendemain(date: string): string {
    if (!date) {
      return '';
    }
    const [a, m, j] = date.split('-').map(Number);
    const d = new Date(a, m - 1, j + 1);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const jj = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${mm}-${jj}`;
  }
}
